export const NUTS_LEVEL_COLOR_MAPPING = {
  0: '#09baa5',
  1: '#81D27D',
  2: '#D18882',
  3: '#8384C9'
}

export const HEATMAP_COLOR_MAPPING = {
  0: '#ffcccc',
  1: '#ff7f7f',
  2: '#ff0000'
}

export const PARTNER_TYPE_COLOR_MAPPING = {
  lead: '#ff6d10',
  partner: '#1c7b41'
}

export const customMapStyles = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5'
      }
    ]
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161'
      }
    ]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5'
      }
    ]
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffeb3b'
      },
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#797979'
      },
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#bdbdbd'
      },
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bdbdbd'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f0f0e8'
      },
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dadada'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5'
      }
    ]
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c9c9c9'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#a6d0ff'
      },
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  }
]

export const SHOW_FILTER_SEARCH_LIMIT = 7

export const SELECTED_FILTER_MAX_LINES = 2

export const SearchableOptions = Object.freeze({
  PROJECTS: 'projects',
  PROGRAMMES: 'programmes',
  PARTNERS: 'partners',
  COUNTRIES_AND_REGIONS: 'countries_and_regions'
})

// RESULTS_PER_PAGE is also set in the backend so don't change this value without doing the change also in the backend
export const RESULTS_PER_PAGE = 30

export const DEFAULT_PROJECT_START_YEAR_MIN = 2000
export const DEFAULT_PROJECT_START_YEAR_MAX = 2025
export const DEFAULT_PROJECT_END_YEAR_MIN = 2000
export const DEFAULT_PROJECT_END_YEAR_MAX = 2025
export const INCLUDED_VALUE = 'included'

export const PermissionStatusStates = Object.freeze({
  DENIED: 'denied',
  GRANTED: 'granted',
  PROMPT: 'prompt'
})

export const LIMIT_WHEN_CLUSTER_CLICK_WILL_ZOOM = 100

export const OTHER_EUSDR_RELATED = 'Other (EUSDR related)'
export const OTHER_EUSBSR_RELATED = 'Other  (EUSBSR related)'
export const ENPI_ENI_CROSS_BORDER = 'ENPI/ENI cross-border'
export const INTERREG_IPA_CROSS_BORDER = 'Interreg-IPA cross-border'
export const IPA_IPA_CROSS_BORDER_COOPERATION = 'IPA-IPA cross-border'

export const PERIOD_2000_2006 = '2000-2006'

export const MAX_SEARCH_WORDS = 20
